import { css } from 'styled-components';

import { BodyXSmallRegular, Colour } from '@xemplo/style-constants';

export const helperTextStyles = css`
  ${BodyXSmallRegular};
  padding: 8px 16px 0 16px;
  word-break: break-word;
  overflow-wrap: anywhere;
`;

export const errorMessageStyles = css`
  ${helperTextStyles};
  color: ${Colour.Red[600]};
`;

export const descriptionStyles = css`
  ${helperTextStyles};
  color: ${Colour.Dark[60]};
`;
